export default __webpack_public_path__ + "static/media/166825419_116743077166881_4298800367171544817_n.6f0c4b6b.jpg";